// GameAnalyticsSDK.js
var GameAnalyticsSdk = pc.createScript('gameAnalyticsSdk');

// initialize code called once per entity
GameAnalyticsSdk.prototype.initialize = function() {
    GameAnalyticsSdk.instance = this;
    this.gaStatus = false;
    //this.configureGameAnalytics();
};

GameAnalyticsSdk.prototype.configureGameAnalytics = function () {
    this.gaStatus = true;
    GameAnalytics("setEnabledInfoLog", true);
    GameAnalytics("setEnabledVerboseLog", true);
    GameAnalytics("configureBuild", "v1.2.7");
    GameAnalytics("initialize", "7f6442d22813bc078ec4b93cee700d15", "5049f191ec6db2ed0bc3627ec2d2ac34c7e17337");
};

